import { AxiosResponse } from "axios";
import { FileManagementUploadSearchDto, FileManagementSearchInput as FileManagementSearchInput, FileManagementImportSearchDto } from "../../Model/Dto/FileManagement";
import { SearchResult } from "../../Model/Dto/SearchResult";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import * as ApiUrls from "./ApiUrl.FileManagement";

export const FileManagementService = {
  UploadSearch: (searchInput: FileManagementSearchInput): Promise<AxiosResponse<SearchResult<FileManagementUploadSearchDto>>> => {
    return axiosCoreInstance.post(ApiUrls.FileManagementUploadSearch, searchInput)
  },
  ImportSearch: (searchInput: FileManagementSearchInput): Promise<AxiosResponse<SearchResult<FileManagementImportSearchDto>>> => {
    return axiosCoreInstance.post(ApiUrls.FileManagementImportSearch, searchInput)
  },
  UploadDocument: (formData: FormData, headers: any): Promise<AxiosResponse<void>> => axiosCoreInstance.post(ApiUrls.FileManagementUpload, formData, { headers: headers }),
  ImportDownload:(id: number): Promise<AxiosResponse<string>> => axiosCoreInstance.get(`${ApiUrls.FileManagementImport}${id}`)
}
